import dayjs from 'dayjs';
import { TableBody as Body } from '@mui/material';
import { CloseOutlined } from '@mui/icons-material';

import { HeaderProperties } from '../../../shared/uiComponents/Table/tableProperties';
import { CustomTableRow, RowTableCell } from '../../../shared/uiComponents/Table/tableHelpers';
import { ModifiedSessionDetails } from '../BillingReports/MBHReport/tableInfo';

import { BillingProperties } from '../../../redux/API/ClientAPIHelpers/billingProperties';

export const Headers: HeaderProperties[] = [
	{ id: '1', name: 'Client Name', orderBy: 'client.fullName' },
	{ id: '2', name: 'Session Date', orderBy: 'sessionDate' },
	{ id: '3', name: 'Session Type' },
	{ id: '4', name: 'Provider' },
	{ id: '5', name: 'Modified' },
	{ id: '6', name: 'Submit Date', orderBy: 'reportSubmittedAt' },
	{ id: '7', name: 'Download Date', orderBy: 'reportExportedAt' },
];

export const TableBody = ({ data }: { data: BillingProperties[] }) => (
	<Body>
		{data.map((row, index) => (
			<CustomTableRow key={index}>
				<RowTableCell>{row.client.fullName}</RowTableCell>
				<RowTableCell>{dayjs.utc(row.sessionDate).format('MM-DD-YYYY')}</RowTableCell>
				<RowTableCell>{row.sessionType.name}</RowTableCell>
				<RowTableCell>{row.billedBy ? row.billedBy.fullName : '-'}</RowTableCell>
				<RowTableCell>
					{row.sessionDateModifiedDetails ? (
						<ModifiedSessionDetails item={row.sessionDateModifiedDetails} />
					) : (
						<CloseOutlined />
					)}
				</RowTableCell>
				<RowTableCell>{dayjs(row.reportSubmittedAt).format('MM-DD-YYYY')}</RowTableCell>
				<RowTableCell>
					{row.reportExportedAt ? dayjs(row.reportExportedAt).format('MM-DD-YYYY') : 'Not downloaded'}
				</RowTableCell>
			</CustomTableRow>
		))}
	</Body>
);
